// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__27KIg","ChartFooter":"Footer_ChartFooter__15JCe"};